export default __webpack_public_path__ + "static/media/t3.a12da50b.jpg";